export { default } from "./StaticBulletList";
